// @flow
import React from "react"
import { Route, Redirect } from "react-router-dom"
import Clouds from "../Clouds"
import { Container } from "../UI/Modal"
import Signup from "./Signup"
import Login from "./Login"
import Forgot from "./Forgot"
import Reset from "./Reset"
import Pending from "./Pending"

const PublicArea = () =>
  <Clouds>
    <Container>
      <Route path="/auth/login" component={Login} />
      <Route path="/auth/sign-up" component={Signup} />
      <Route path="/auth/forgot" component={Forgot} />
      <Route path="/auth/reset" component={Reset} />
      <Route path="/auth/pending" component={Pending} />
      <Route
        path="/auth"
        exact
        component={() => <Redirect to="/auth/login" />}
      />
    </Container>
  </Clouds>

export default PublicArea



// WEBPACK FOOTER //
// ./src/PublicArea/index.js